// Port of api/fuel/app/classes/filter/search/games/rules/query/official_duration.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'official_duration',
	isRange: function() { return true },
	fieldLow: function() { return 'g.game_time_min' },
	fieldHigh: function() { return 'g.game_time_max' }
})
